import { createStyles, makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex'
    },
    formControl: {
      margin: theme.spacing(3)
    },
    formElement: {
      padding: '20px'
    },
    title: {
      textAlign: 'center'
    }
  })
)
